import { render, staticRenderFns } from "./BInputRoles.vue?vue&type=template&id=800730c2&scoped=true"
import script from "./BInputRoles.vue?vue&type=script&lang=js"
export * from "./BInputRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800730c2",
  null
  
)

export default component.exports